import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../widgets';
import BotonComponent from '../dashboard/components/BotonNuevo';
import {
  allTelefonosAction,
  setActivoTelefonosAction,
} from './TelefonosAction';
import FormTelefonos from './components/FormTelefonos';
import ListadoTelefonos from './components/ListadoTelefonos';

const TelefonosView = ({ idUsuario, idEntidad }) => {
  const dispatch = Redux.useDispatch();

  const telefonosStore = Redux.useSelector((state) => state.telefonos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {telefonosStore.all.length < 3 && (
          <BotonComponent
            click={async () => {
              await setActivoTelefonosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoTelefonosAction(dispatch, null);
            await allTelefonosAction(dispatch, {
              ...telefonosStore.params,
              idUsuario,
              idEntidad,
            });
          }}
          disabled={
            telefonosStore.all.length === 0 && telefonosStore.loadingAll
          }
          white
          refreshIcon
          text={telefonosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoTelefonos
          setOpenModalForm={(value) => setOpenModalForm(value)}
          params={{ idUsuario, idEntidad }}
        />
      </Grid>
      <ModalComponent
        id="modalFormTelefonos"
        title={
          telefonosStore.activo
            ? `Editar teléfono: ${telefonosStore.activo.numero}`
            : 'Nuevo telénofo'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormTelefonos
          activo={telefonosStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
          params={{ idUsuario, idEntidad }}
        />
      </ModalComponent>
    </Grid>
  );
};

export default TelefonosView;
